import { Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useMainContext } from "../../../../../context/useMainContext";
import { useEffect, useState } from "react";

export default ({ row, col }) => {
  const { rows, setTextFieldEditModalOpen, setCurrentTextFieldData, isGuest } = useMainContext();
  const [value, setValue] = useState(row[col] || "");

  useEffect(() => {
    setValue(rows.find((r) => r.id === row.id)?.[col]);
  }, [rows]);

  const handleOpenModal = () => {
    setCurrentTextFieldData({
      row,
      col,
      value: value || "",
    });
    setTextFieldEditModalOpen(true);
  };

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleOpenModal}
      disabled={isGuest}
      fullWidth
      startIcon={<EditOutlinedIcon fontSize="small" />}
      sx={{
        minHeight: "30.35px",
        justifyContent: "flex-start",
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value || ""}
      </span>
    </Button>
  );
};
